export const SMS_TEMPLATES_QUERY_KEY = ['resource-metrics', 'sms-templates'];
export const CONFIG_QUERY_KEY = 'config';
export const FLOWS_QUERY_KEY = 'flows';
export const FUNCTIONS_QUERY_KEY = 'functions';
export const DISCLAIMER_QUERY_KEY = 'disclaimer';
export const KNOWLEDGE_BASE_QUERY_KEY = 'knowledge-base';
export const PRONUNCIATION_QUERY_KEY = 'pronunciations';
export const SMS_CREDENTIALS_QUERY_KEY = 'sms-credentials';
export const VARIANT_MANAGEMENT_QUERY_KEY = 'variant-management';
export const VOICE_TUNING_QUERY_KEY = 'voice-tuning';
export const TELEPHONE_MUTATION_KEY = 'jupiter-telephony';
export const ALL_CONNECTION_QUERY_KEY = 'all-environments';
export const VOICE_TUNING_MUTATION_KEY = 'voice-tuning-settings';
export const LLM_ANNOTATIONS_MUTATION_KEY = 'llm-call-annotations';
export const MULTICHANNEL_DASHBOARDS_QUERY_KEY = 'multi-channel-dashboards';
export const SOURCE_HUB_QUERY_KEY = 'sourceHub';
export const PARAGON_SECRETS_QUERY_KEY = 'paragonSecrets';
export const WEBRTC_CONNECTION_QUERY_KEY = 'webrtc-connection';
export const KB_TOPICS_PREVIEW_QUERY_KEY = 'kb-topics-preview';

// Resource keys previously hardcoded in hooks
export const API_CONFIG_QUERY_KEY = 'apiConfig';
export const API_KEYS_QUERY_KEY = 'apiKeys';
export const PATS_QUERY_KEY = 'pats';
export const CONVERSATIONS_REVIEW_SETTINGS_QUERY_KEY =
  'conversationsReviewSetting';
export const CONVERSATION_REVIEW_VIEWS_QUERY_KEY = 'conversationReviewViews';
export const CUSTOM_METRICS_QUERY_KEY = 'customMetrics';
export const DEPLOYMENTS_QUERY_KEY = 'deployments';
export const ACTIVE_DEPLOYMENTS_QUERY_KEY = 'active';
export const AB_TESTS_QUERY_KEY = 'ab-tests';
export const ACTIVE_AB_TEST_QUERY_KEY = 'active';
export const TEST_CASES_QUERY_KEY = 'testCases';
export const TEST_RUNS_QUERY_KEY = 'testRuns';
export const TEST_SETS_QUERY_KEY = 'testSets';
export const AGENT_CONFIG_FILE_QUERY_KEY = 'agent-config-file';
export const EXTERNAL_SOURCE_QUERY_KEY = 'external_source';

export const AGGREGATED_DASHBOARDS_QUERY_KEY = 'aggregatedDashboards';
export const AGGREGATED_DASHBOARD_QUERY_KEY = 'aggregatedDashboard';
export const LIST_METRICS_QUERY_KEY = 'list-metrics';

// Conversations revamp
export const CONVERSATION_QUERY_KEY = 'conversation';
export const CONVERSATIONS_LIST_QUERY_KEY = 'conversationsList';
export const CONVERSATION_DETAIL_QUERY_KEY = 'conversationDetail';
export const CONVERSATION_VIEWS_QUERY_KEY = 'conversationViews';
export const CONVERSATION_USER_SETTINGS_QUERY_KEY = 'conversationUserSettings';
export const LIVE_CONVERSATIONS_QUERY_KEY = 'liveConversations';
export const LIVE_CONVERSATION_QUERY_KEY = 'liveConversation';
export const CONVERSATION_FILTER_METRICS_QUERY_KEY =
  'conversationFilterMetrics';

// Metronome billing (account-scoped)
export const METRONOME_BILLING_CONFIG_QUERY_KEY = 'metronomeBillingConfig';
export const METRONOME_BILLING_BALANCE_QUERY_KEY = 'metronomeBillingBalance';
export const METRONOME_BILLING_CONSUMPTION_QUERY_KEY =
  'metronomeBillingConsumption';
export const METRONOME_BILLING_INVOICES_QUERY_KEY = 'metronomeBillingInvoices';
export const METRONOME_BILLING_PROJECTS_QUERY_KEY = 'metronomeBillingProjects';
export const METRONOME_BILLING_LEDGER_QUERY_KEY = 'metronomeBillingLedger';

// Factory: project-scoped query key
export const createQueryKey = (
  accountId: string,
  projectId: string,
  resource: string,
  ...params: (string | undefined | null)[]
) => [accountId, projectId, resource, ...params.filter(Boolean)] as string[];

// Factory: account-scoped query key (no projectId)
export const createAccountQueryKey = (
  accountId: string,
  resource: string,
  ...params: (string | undefined | null)[]
) => [accountId, resource, ...params.filter(Boolean)] as string[];
